import { ExamCreate } from './ExamCreate';
import { ExamEdit } from './ExamEdit';
import { ExamList } from './ExamList';

export default {
    create: ExamCreate,
    edit: ExamEdit,
    list: ExamList
}
